import TabellaIsee from "./TabellaIsee";

const ListIsee = (props) => {
  return (
    <>
      <TabellaIsee bands={props} />{" "}
    </>
  );
};

export default ListIsee;
